module.exports = __webpack_public_path__ + "static/media/015_g5_7Artist Detail Screen.c7c2dea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/015_g5_7Artist Detail Screen.png
// module id = 440
// module chunks = 0